import React from "react";
import {Field, ErrorMessage} from "formik";
import TextError from "./TextErrorComponent";
import './form.scss'

//The component Formik for Input text field
function Input (props) {
    const { label, name, isDevice, ...rest } = props;

    return (
        <div className="formControl" style={{"padding": isDevice? "0" : "auto"}}>
            {isDevice ?
                null
                :
                <label htmlFor={name} className="label">{label}</label>
            }
            {isDevice ?
                <Field id={name} name={name} {...rest} className="fieldLessWidth"/>
                :
                <Field id={name} name={name} {...rest} className="field"/>
            }
            <ErrorMessage name={name} component={TextError}/>
        </div>
    )
}
export default Input;
